import {
  DocumentTransitionRequirementResource,
  DocumentTransitionRequirementStatus,
} from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export type UpdateTransitionRequirementPayload = {
  transition: string;
  workflow: string;
  requirement: string;
  status: DocumentTransitionRequirementStatus;
};

export const postUpdateApplicationTransitionRequirement = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  workflowName: string,
  data: UpdateTransitionRequirementPayload,
): Promise<
  NonPaginatedResponse<DocumentTransitionRequirementResource> | undefined
> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/transition/requirements`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        [InceptHeader.WorkflowName]: workflowName,
      },
    },
    { preventDefaultErrorToast: true },
  );
